import styled from 'styled-components';
import { DashboardToolbar } from 'components/ConnectorsDashboard/components/DashboardToolbar/DashboardToolbar';
import { Outlet } from 'react-router';

const StyledConnectorsDashboard = styled.div`
  width: 100%;
  height: 100%;
  padding: 40px;
`;

const ConnectorsDashboard = () => {
  return (
    <StyledConnectorsDashboard data-testid="connectors-dashboard-view">
      <DashboardToolbar />
      <Outlet />
    </StyledConnectorsDashboard>
  );
};

export default ConnectorsDashboard;
